// Cart store — 極簡 reactive store
// see architecture.md#L510 (cart state machine)

function createStore(initial) {
  let state = initial;
  const subscribers = new Set();
  return {
    get: () => state,
    set: (next) => {
      state = next;
      subscribers.forEach((fn) => fn(state));
    },
    subscribe: (fn) => {
      subscribers.add(fn);
      return () => subscribers.delete(fn);
    },
  };
}

export const cartStore = createStore([]);

export function addToCart({ menu_item_id, name, price, qty = 1, modifiers = [] }) {
  const items = cartStore.get();
  // 相同 id + modifiers 合併 qty
  const existing = items.findIndex(
    (i) => i.menu_item_id === menu_item_id && JSON.stringify(i.modifiers) === JSON.stringify(modifiers)
  );
  if (existing >= 0) {
    const next = [...items];
    next[existing] = { ...next[existing], qty: next[existing].qty + qty };
    cartStore.set(next);
  } else {
    cartStore.set([...items, { menu_item_id, name, price, qty, modifiers }]);
  }
}

export function updateQty(idx, newQty) {
  const items = cartStore.get();
  if (newQty <= 0) {
    cartStore.set(items.filter((_, i) => i !== idx));
    return;
  }
  const next = [...items];
  next[idx] = { ...next[idx], qty: newQty };
  cartStore.set(next);
}

export function removeFromCart(idx) {
  cartStore.set(cartStore.get().filter((_, i) => i !== idx));
}

export function clearCart() {
  cartStore.set([]);
}

// 台灣餐飲慣例：菜單定價內含營業稅。tax 恆為 0（保留欄位以相容），total = subtotal。
export function cartTotal() {
  const items = cartStore.get();
  const subtotal = items.reduce((s, i) => s + i.price * i.qty, 0);
  return { subtotal, tax: 0, total: subtotal };
}
